const MENTOR_EXPECTATIONS: Record<string, string> = {
  CONFIDENCE: 'Mettre un jeune en confiance',
  NETWORK: 'Ouvrir mon réseau',
  ENCOURAGEMENT: 'Dynamiser les démarches d\'un jeune',
  REFLECTION: 'Questionner, aider à prendre du recul',
};

export type MentorExpectationValues = keyof typeof MENTOR_EXPECTATIONS;
export const mentorExpectations = Object.keys(MENTOR_EXPECTATIONS) as MentorExpectationValues[];

export default MENTOR_EXPECTATIONS;